import React from 'react';
import { TeamInLeague, TrainingFocus } from '../../../domain/entities';
import { TRAINING_FOCUS_OPTIONS } from '../../../domain/constants';

interface TrainingTeamPanelProps {
    team: TeamInLeague;
    onUpdateTeamTrainingFocus: (focus: TrainingFocus) => void;
}

export const TrainingTeamPanel: React.FC<TrainingTeamPanelProps> = ({ team, onUpdateTeamTrainingFocus }) => {
    return (
        <div className="panel">
            <div className="panel-header">Team-Wide Focus</div>
            <div className="panel-content">
                <div className="form-group">
                    <p>Set the general training schedule for the entire squad. This can be overridden by positional or individual settings.</p>
                    <select id="team-focus-select" value={team.trainingFocus} onChange={e => onUpdateTeamTrainingFocus(e.target.value as TrainingFocus)}>
                        {TRAINING_FOCUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                </div>
            </div>
        </div>
    );
};